const normalizeUrl = url => String(url || '').trim().replace(/\/+$/, '');

const hasSameOrigin = (left, right) => {
  try {
    return new URL(left).origin === new URL(right).origin;
  } catch {
    return left === right;
  }
};

const getBaseUrl = () => {
  const configuredBaseUrl = normalizeUrl(process.env.REACT_APP_BASE_URL);

  if (typeof window !== 'undefined') {
    const browserOrigin = normalizeUrl(window.location.origin);

    if (!configuredBaseUrl) {
      return browserOrigin;
    }

    if (hasSameOrigin(configuredBaseUrl, browserOrigin)) {
      return configuredBaseUrl;
    }

    console.warn(
      `REACT_APP_BASE_URL (${configuredBaseUrl}) difere da origem atual (${browserOrigin}). Usando a origem do navegador para o Cognito.`
    );
    return browserOrigin;
  }

  return configuredBaseUrl || 'http://localhost:3000';
};

export const getOidcConfig = () => {
  const cognitoIssuer = process.env.REACT_APP_COGNITO_DOMAIN;
  const clientId = process.env.REACT_APP_COGNITO_CLIENT_ID;
  const baseUrl = getBaseUrl();

  if (!cognitoIssuer || !clientId) {
    throw new Error(
      'REACT_APP_COGNITO_DOMAIN e REACT_APP_COGNITO_CLIENT_ID devem estar configurados'
    );
  }

  return {
    authority: cognitoIssuer,
    client_id: clientId,
    redirect_uri: baseUrl,
    post_logout_redirect_uri: `${baseUrl}/log_in`,
    response_type: 'code',
    scope: 'email openid phone',
    automaticSilentRenew: true,
    silent_redirect_uri: `${baseUrl}/silent-renew.html`,
    loadUserInfo: true,
    extraQueryParams: {
      lang: 'pt-BR',
    },
  };
};

export const getCognitoLogoutUrl = () => {
  const cognitoHostedDomain = process.env.REACT_APP_COGNITO_HOSTED_DOMAIN;
  const clientId = process.env.REACT_APP_COGNITO_CLIENT_ID;
  const baseUrl = getBaseUrl();

  if (!cognitoHostedDomain || !clientId) {
    throw new Error('Configuração do Cognito não encontrada');
  }

  return `${cognitoHostedDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(
    `${baseUrl}/log_in`
  )}`;
};
